import React from 'react';
import { FormSelectChoice, setRef, ExtendedFieldId, FieldId } from '@sheerid/jslib';

interface RadioProps {
    className?: string;
    fieldId: FieldId | ExtendedFieldId;
    onChange: any;
    option: FormSelectChoice;
    value?: FormSelectChoice;
    isChecked: boolean;
}

const Radio = ({
    isChecked,
    option,
    onChange,
    fieldId,
}: RadioProps) => {
    const itemToString = (item: FormSelectChoice) => (item ? item.label : '');

    const handleRadioOnKeyDown = (e: React.KeyboardEvent<HTMLLabelElement>, option: FormSelectChoice) => {
        if (e.key === ' ' || e.key === 'Enter') {
            e.preventDefault();
            onChange(option);
        }
    };

    return (
        <div className="sid-radio-button">
            <input
                id={itemToString(option)}
                onChange={() => onChange(option)}
                value={option.value}
                type="radio"
                checked={isChecked}
                aria-checked={isChecked}
            />
            <label
                tabIndex={0}
                htmlFor={itemToString(option)}
                onKeyDown={(e: React.KeyboardEvent<HTMLLabelElement>) => handleRadioOnKeyDown(e, option)}
                ref={input => setRef(fieldId, input)}
            >
                    {option.label}
            </label>
        </div>
    );
};


export const RadioComponent = Radio;
